import {
  getGretaAIChatRenderableTurns,
  getIsGretaAIChatUserRole,
} from '../../GretaAIChatMessage'

export function getIsGretaAIChatLastTurnUser(messages) {
  return getIsGretaAIChatUserRole(
    getGretaAIChatRenderableTurns(messages).at(-1)?.role
  )
}

export function withGretaAIChatRetryFlag(messages) {
  const lastTurn = getGretaAIChatRenderableTurns(messages).at(-1)

  return messages.map(message =>
    message === lastTurn ? { ...message, canRetry: true } : message
  )
}
